import type { ReactNode } from 'react';
import { fieldHintId } from './fieldParts';

/** Case à cocher libellée, dans un cadre cliquable ; hint : précision sous le libellé */
export function CheckboxField({
  id,
  label,
  hint,
  checked,
  onChange,
}: {
  id: string;
  label: ReactNode;
  hint?: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <label
      htmlFor={id}
      className="flex items-start gap-3 p-4 border border-slate-200 rounded-xl bg-card cursor-pointer hover:border-slate-300 transition-colors shadow-sm"
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        aria-describedby={hint ? fieldHintId(id) : undefined}
        className="w-5 h-5 mt-px accent-blue-600 shrink-0"
      />
      <span className="text-sm">
        <span className="font-medium text-slate-700">{label}</span>
        {hint && (
          <span id={fieldHintId(id)} className="block mt-0.5 text-slate-500">
            {hint}
          </span>
        )}
      </span>
    </label>
  );
}
